<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-12 d-inline-block mt-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">دسته بندی :</span>
                        </div>
                        <vs-select :data="categories" :mode="'create'"
                                   :header="{multiple: false, label: 'name'}"
                                   @onChange="onSelectCategory"></vs-select>
                    </div>
                </div>
                <div class="col-lg-3 col-md-5 col-12 m-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                        <button type="button" class="d-inline-block btn btn-info mx-2 barcode"
                                @click="openBarcode"><i
                                class="fa fa-camera"></i></button>
                    </div>
                </div>

                <div class="col-lg-4 col-md-11 col-12 text-center m-2">
                    <button class="btn btn-danger" @click="onReturn" v-if="fromEdit">ثبت مرجوعی</button>
                    <button class="btn btn-primary mx-1" @click="onModalButtonClick">افزودن محصول جدید</button>
                    <button class="btn btn-primary mx-1" @click="onModalShow">مشاهده فاکتور</button>
                </div>
            </div>


        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-4">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-4">
                            <span>موجودی: </span>
                            <span>{{item.stock}} {{item.unitName}}</span>
                        </div>
                        <!--<div class="col-md-2">-->
                        <!--<span>تعداد: </span>-->
                        <!--<span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>-->
                        <!--<span v-else>{{item.unitVal}}</span>-->
                        <!--</div>-->
                        <div class="col-md-4">
                            <span>قیمت: </span>
                            <span>{{item.price == null ? 0 :item.price.toLocaleString()}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>
                            <span>موجودی انبار:</span>
                            <span>{{item.stock}} {{item.unitName}}</span>
                            <br>
                            <span>قیمت:</span>
                            <span>{{item.price == null ? 0 : item.price.toLocaleString()}}</span>
                            <br>
                            <!--<span>تعداد:</span>-->
                            <!--<span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>-->
                            <!--<span v-else>{{item.unitVal}}</span>-->
                            <!--<br>-->
                            <span>بارکد:</span>
                            <span>{{item.barcode}}</span>
                        </div>
                        <div class="col-4">
                            <img src="../assets/img/placeholder.png" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 mt-5 text-center" v-if="products !== undefined && products.length < 1">
                <h3 class="no-item-alert">محصولی یافت نشد!</h3>
            </div>
            <div class="col-lg-12 mt-5"
                 :style="[autoload && products.length < dataCount ? {'height': '125px'} : {'height': 'initial'}]">
                <div class="sk-circle" id="loading"
                     :style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center mb-3 mt-1"
                 @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>
            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-nowrap">نام محصول</th>
                                        <th class="text-center text-nowrap">قیمت خرید</th>
                                        <th class="text-center text-nowrap">تعداد</th>
                                        <th class="text-center text-nowrap" v-if="!isProducer">قیمت فروش</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in cart">
                                        <td class="product-remove-button pb-0"><a class="text-danger"
                                                                                  @click="onRemoveProductClicked(index)"><i
                                                class="fa fa-close"></i></a></td>
                                        <td class="text-nowrap mt-2 pb-0">{{item.productName}}</td>
                                        <td class="text-center min-vw-100 pb-0">
                                            <input class="form-control" style="min-width: 6rem;" type="number"
                                                   v-model="item.price" @input="thousandSeprator(item)">
                                            <small class="text-nowrap mt-2">{{item.priceShow}}</small>
                                        </td>
                                        <td class="text-center pb-0">
                                            <input class="form-control" style="min-width: 4rem;" type="number"
                                                   v-model="item.unitVal">
                                            <small class="text-nowrap mt-2">{{item.unitName}}</small>
                                        </td>
                                        <td class="text-center pb-0" v-if="!isProducer">
                                            <input class="form-control" style="min-width: 6rem;" type="number"
                                                   v-model="item.salesPrice" @input="thousandSeprator2(item)">
                                            <small class="text-nowrap mt-2">{{item.salesPriceShow}}</small>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                                    است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="voucher.description"
                                       placeholder="توضیحات">
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-6 col-sm-6 w-100 text-right">

                                        <div class="row">
                                            <div class="col-md-6">
                                                <span>تعداد کل: </span>
                                                <span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                                <span v-else>{{voucher.overallAmount}}</span>
                                                &nbsp;&nbsp;&nbsp;
                                            </div>
                                            <div class="col-md-6">
                                                <span>مبلغ کل: </span>
                                                <span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت خرید به درستی وارد نشده است!</span>
                                                <span v-else>{{voucher.overallPrice.toLocaleString()}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" col-md-6 col-sm-6 w-100 text-right d-inline-flex">
                                        <button type="button" class="btn btn-secondary m-1" data-dismiss="modal">بستن
                                        </button>
                                        <button type="button" class="btn btn-success m-1" @click="onPaymentClicked"
                                        >پرداخت
                                        </button>
                                        <button type="button" class="d-inline-block btn btn-success m-1"
                                                @click="onPrintClicked"><i
                                                class="fa fa-print"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- ------------------------------------------------------------------------------------------->
        <div class="d-none" id="printMe">
            <h5>محصولات فاکتور</h5>
            <div class="table-responsive">
                <table class="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th class="text-nowrap">نام محصول</th>
                        <th class="text-center text-nowrap">قیمت خرید</th>
                        <th class="text-center text-nowrap">تعداد</th>
                        <th class="text-center text-nowrap">قیمت فروش</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in cart">
                        <td class="text-nowrap">{{item.productName}}</td>
                        <td class="text-center text-nowrap">{{item.price}}</td>
                        <td class="text-center text-nowrap">{{item.unitVal}}</td>
                        <td class="text-center text-nowrap">{{item.salesPrice}}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td class="text-center font-weight-bold">تعداد محصولات</td>
                        <td class="text-center font-weight-bold">{{voucher.overallAmount}}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td class="text-center font-weight-bold">جمع فاکتور</td>
                        <td class="text-center font-weight-bold">{{voucher.overallPrice.toLocaleString()}}</td>
                    </tr>
                    </tbody>
                </table>
                <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                    است!</h4>
            </div>
        </div>
        <!-- ------------------------------------------------------------------------------------------->
        <!--*****************************************************************************************************************-->
        <div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="barcodTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="barcodTitle">خواندن بارکد
                            محصول</h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3">
                        <div class="row">
                            <div class="col-12">

                                <StreamBarcodeReader
                                        @decode="(a, b, c) => onDecode(a, b, c)"
                                        @loaded="() => onLoaded()"
                                ></StreamBarcodeReader>
                                <h5 class="col-12 text-center m-3">
                                    {{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block mt-3">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <!--<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>-->
                        <!--<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>-->
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="productModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitle">ایجاد
                            محصول</h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3">
                        <div class="row">
                            <div class="col-lg-9 col-md-12 col-sm-12 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">دسته بندی</span>
                                    </div>
                                    <vs-select :data="categories" :selected-val="preselectedCategory"
                                               :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onCategoryChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-12 col-sm-12 text-center">
                                <button class="btn btn-primary bg-danger-grad border-0"
                                        @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom"
                                        title="افزودن دسته بندی">افزودن دسته بندی
                                </button>
                            </div>
                            <div class="col-lg-12 mt-3 mt-lg-0">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام محصول</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.productName">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">واحد</span>
                                    </div>
                                    <vs-select :data="units" :selected-val="preselectedUnit"
                                               :mode="'create'" :header="{multiple: false, label: 'unitName'}"
                                               @onChange="onUnitChange"></vs-select>
                                </div>
                            </div>
                            <!--<div class="col-lg-6 mt-3">-->
                            <!--<div class="input-group">-->
                            <!--<button type="button" class="d-inline-block btn btn-info mx-2 barcode"-->
                            <!--@click="openBarcode"><i-->
                            <!--class="fa fa-camera"></i></button>-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">بارکد</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" type="number" v-model="product.barcode"  placeholder="برای قرائت بارکد روی آیکون کلیک کنید">-->
                            <!--</div>-->
                            <!--</div>-->
                        </div>

                    </div>
                    <div class="modal-footer d-block mt-3">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onProductModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="category-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger glow-warning">
                        <h5 class="modal-title text-white">افزودن دسته بندی</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row text-center">
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">عنوان دسته بندی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="categoryName">
                                </div>
                            </div>
                            <!--<div class="col-lg-6 mb-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">دسته بندی مادر</span>-->
                            <!--</div>-->
                            <!--<vs-select-->
                            <!--:data="categories"-->

                            <!--:mode="'create'"-->
                            <!--:header="{multiple: false, label: 'name'}"-->
                            <!--@onChange="onCategoryChange"-->
                            <!--&gt;</vs-select>-->
                            <!--</div>-->
                            <!--</div>-->
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onCreateCategory">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import EventBus from "../_framework/event-bus.js";
    import VueHtmlToPaper from 'vue-html-to-paper';
    import {StreamBarcodeReader} from "vue-barcode-reader";
    import VsSelect from '../_framework/VsSelect.vue';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'buy-from-outsource',
        components: {
            VsSelect,
            StreamBarcodeReader
        },
        data() {
            return {
                products: [],
                categories: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    // outsourceId: 0,
                    showAll: false
                },
                searchString: "",
                modalProductName: "",
                cart: [],
                voucher: {
                    description: "",
                    serveOutSourceId: 0,
                    voucherProductDto: [],
                    outSourceName: "",
                    overallAmount: 0,
                    overallPrice: 0
                },
                tempVoucher: [],
                outSourceName: "",
                dataCount: 0,

                listView: false,
                autoload: false,

                userId: 0,
                companyId: 0,
                fromEdit: false,
                barcode: "",
                outsourceId: 0,
                categoryName: "",
                preselectedCategory: {},
                product: {
                    productName: "",
                    unitId: 0,
                    barcode: "",
                    categoryId: 0,
                },
                units: [],
                preselectedUnit: {},
                isProducer: false,
                producerMobile: "",
                companyPostName: "",

                oldOutsourceList: [],

                prOutsource: {
                    id: 0,
                    name: "",
                    price: 0,
                },
                baseProduct: {
                    voucherId: 0,
                    productId: 0,
                    name: "",
                    unitval: 0,
                    unit: ""
                },
                isSending: false,

            }
        },
        mounted() {


            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);
            this.userId = localStorage.getItem("userId");
            this.companyId = localStorage.getItem("companyId");

            this.companyPostName = localStorage.getItem("companyPostName");
            if (this.companyPostName === 'تامین کننده') {
                this.isProducer = true;
                this.producerMobile = localStorage.getItem("phoneNumber");
            }

            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });

            this.outsourceId = this.$route.params.id;
            this.baseProduct = this.$route.params.baseProduct;

            this.prOutsource = this.$route.params.prOutsource;
            this.oldOutsourceList = this.$route.params.oldOutsourceList;

            console.log(this.baseProduct)
            console.log(this.oldOutsourceList)

            // console.log(this.$route.params.voucher)
            this.fromEdit = this.$route.params.fromEdit;
            new BaseService('product').getList(this.queryParams).then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                let index = 0;
                for (let i of this.products) {
                    if (i.id === this.baseProduct.productId) {
                        this.products.splice(index, 1);
                    }
                    index++;
                }
                if (this.$route.params.voucher !== undefined) {
                    this.cart = this.$route.params.voucher.voucherProductDto;

                    this.validateProductsList();
                }
                $("#loading").hide();
            }).catch(error => {
                console.log(error)
                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
            });
            new BaseService('outsource').getById(this.$route.params.id).then(response => {
                this.outSourceName = response.data.outSourceName;
            }).catch(error => {
                console.log(error)
                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
            });

            if (localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`) === null) {
                localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, "[]");
            }

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts();

                    }
                });
            }
            new BaseService('categories').getAll().then(response => {
                this.categories = response.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            this.getUnits();
        },
        methods: {
            getUnits() {
                new BaseService('units').getAll().then(response => {
                    this.units = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });

            },
            getCategories() {
                new BaseService('categories').getAll().then(response => {
                    this.categories = response.data;
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            getProducts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    let index = 0;
                    for (let i of this.products) {
                        console.log(this.baseProduct.productId)
                        if (i.id === this.baseProduct.productId) {

                            this.products.splice(i, 1);
                            console.log(this.products)
                        }
                    }
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onSelectCategory(val) {
                this.queryParams.categoryId = val.id;
                this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products = response.data.data;
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products = response.data.data;
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            validateProductsList() {
                for (let item of this.cart) {
                    for (let product of this.products) {
                        if (item.productName === product.productName) {
                            product.unitVal = item.unitVal;
                            product.price = item.salesPrice;
                            product.productId = item.productId;
                        }
                    }
                }
            },
            onCardClicked(e, index) {
                let flag = false;
                let i = 0;
                let offset = 0;
                for (let item of this.cart) {
                    if (item.productName === this.products[index].productName) {
                        flag = true;
                        offset = i;
                    }
                    i++;
                }
                if (flag === false) {
                    this.products[index].unitVal++;
                    Vue.set(this.products[index], "originalPrice", this.products[index].price);
                    Vue.set(this.products[index], "salesPrice", this.products[index].sellPrice);
                    this.cart.push(this.products[index]);
                } else {
                    this.cart[offset].unitVal++;
                    //this.products[index].unitVal++;
                }
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.cart[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                }
                this.cart.splice(index, 1);

            },
            onModalShow() {
                for (let i of this.cart) {
                    i.priceShow = i.price === null ? 0 : i.price.toLocaleString();
                    i.salesPriceShow = i.salesPrice === null ? 0 : i.salesPrice.toLocaleString();
                }
                $("#voucherData").modal("show");
            },
            onModalOk() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.price = item.price === null ? 0 : parseInt(item.price);
                        item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                        Vue.set(item, "productId", item.id);
                    }
                    if (this.$route.params.voucher !== undefined) {
                        this.voucher = this.$route.params.voucher;
                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
                        this.tempVoucher[this.voucher.voucherIndex] = this.voucher;
                        localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    } else {
                        this.voucher.voucherProductDto = this.cart;
                        this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                        this.voucher.outSourceName = this.outSourceName;

                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
                        this.tempVoucher.push(this.voucher);
                        localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    }

                    $("#voucherData").modal("hide");
                    this.$noty.info("فاکتور ذخیره شد. برای تکمیل عملیات به بخش بایگانی، فاکتورهای باز مراجعه کنید.");
                    for (let item of this.products) {
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
                /*new BaseService('voucher').create(this.voucher).then(response => {
                    this.$noty.success("موفقیت آمیز!");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })*/
            },
            onPaymentClicked() {

                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    if (this.cart.length < 1) {
                        if (confirm("هیچ کالایی مصرف نشده است؟")) {
                            // for (let item of this.cart) {
                            //     item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                            //     item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                            //     item.price = item.price === null ? 0 : parseInt(item.price);
                            //     item.sellPrice = item.salesPrice;
                            //     Vue.set(item, "productId", item.id);
                            // }
                            // this.voucher.voucherProductDto = this.cart;
                            this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                            this.voucher.outSourceName = this.outSourceName;
                            this.voucher.productVoucherId = this.baseProduct.voucherId;
                            this.voucher.serveOutSourceUUId = parseInt(this.prOutsource.price);
                            console.log(this.voucher)
                            $("#voucherData").modal("hide");

                            let obj = {
                                name: 'productionPayment',
                                params: {
                                    voucher: this.voucher,
                                    type: "production",
                                    baseProduct: this.baseProduct,
                                    prOutsource: this.prOutsource,
                                    oldOutsourceList: this.oldOutsourceList
                                }
                            };
                            this.$router.push(obj);
                        }
                    } else {
                        for (let item of this.cart) {
                            item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                            item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                            item.price = item.price === null ? 0 : parseInt(item.price);
                            item.sellPrice = item.salesPrice;
                            Vue.set(item, "productId", item.id);
                        }
                        this.voucher.voucherProductDto = this.cart;
                        this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                        this.voucher.outSourceName = this.outSourceName;
                        this.voucher.productVoucherId = this.baseProduct.voucherId;
                        this.voucher.serveOutSourceUUId = parseInt(this.prOutsource.price);
                        console.log(this.voucher)
                        $("#voucherData").modal("hide");

                        let obj = {
                            name: 'productionPayment',
                            params: {
                                voucher: this.voucher,
                                type: "production",
                                baseProduct: this.baseProduct,
                                prOutsource: this.prOutsource,
                                oldOutsourceList: this.oldOutsourceList
                            }
                        };
                        this.$router.push(obj);
                    }

                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }

            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            calculateOverallAmount() {
                let amount = 0;
                for (let item of this.cart) {
                    amount += parseFloat(item.unitVal);
                }
                this.voucher.overallAmount = amount;
            },
            calculateOverallPrice() {
                let price = 0;
                for (let item of this.cart) {
                    price += (parseFloat(item.unitVal) * parseInt(item.price));
                }
                this.voucher.overallPrice = price;
            },
            onReturn() {
                if (confirm("در صورت تایید اطلاعات پرداخت خرید و کالاهای آن حذف میشوند. آیا مرجوعی را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {


                        let obj = {
                            name: 'home',

                        };
                        this.$router.push(obj);
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            onDecode(a, b, c) {
                console.log(a, b, c);
                this.barcode = a;
                this.searchString = a;
                this.onSearchInput();
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                console.log("load");
            },
            openBarcode() {
                this.barcode = "";
                $("#barcodeModal").modal("show");
            },
            thousandSeprator(a) {

                let amount = a.price;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                a.priceShow = showprice;

            },
            thousandSeprator2(a) {

                let amount = a.salesPrice;
                let showprice = "";

                if (amount !== '' && amount !== undefined && amount !== 0 && amount !== '0' && amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                a.salesPriceShow = showprice;

            },
            onModalButtonClick() {
                $("#productModal").modal("show");
                let na = this.product.productName;
                this.product = {};
                if (this.preselectedUnit.id !== null) {
                    this.product.unitId = this.preselectedUnit.id;
                }
                if (this.preselectedCategory.id !== null) {
                    this.product.categoryId = this.preselectedCategory.id;
                }
                if (na !== null && na !== '') {
                    this.product.productName = na;
                }
            },
            onCategoryChange(e) {
                if (e && e.id != null) {
                    this.preselectedCategory = e;
                    this.product.categoryId = e.id;
                }
            },
            onAddCategoryClicked() {
                $("#category-modal").modal("show");
                // this.$router.push({name: 'category'});
            },
            onUnitChange(e) {
                if (e && e.id != null) {
                    this.preselectedUnit = e;
                    this.product.unitId = e.id;
                }
            },
            onProductModalOk() {
                this.onCreateProduct(this.product);
            },
            onCreateProduct(product) {
                if (!this.isSending) {
                    this.isSending = true;
                    console.log(product)
                    if (product.categoryId === undefined || product.categoryId === null) {
                        Utils.handleErrorWithNotification("لطفا دسته بندی را انتخاب کنید", this.$noty);
                    } else if (product.unitId === undefined || product.unitId === null) {
                        Utils.handleErrorWithNotification("لطفا واحد را انتخاب کنید", this.$noty);
                    } else {
                        product.rowVersion = this.generateUuid();
                        new BaseService('product').create(product).then(response => {
                            this.$noty.success("موفقیت آمیز!");
                            $("#productModal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                                this.products = response.data.data;
                                $("#loading").hide();
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                        })
                    }
                }
            },
            onCreateCategory() {
                if (!this.isSending) {
                    this.isSending = true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: 0,
                        // parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').create(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت افزوده شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                next();
            }
        },
        watch: {
            cart: {
                handler(val) {
                    this.calculateOverallAmount();
                    this.calculateOverallPrice();
                },
                deep: true
            }
        }
    }
</script>
<style>
    @media (max-width: 991px) {
        .barcode {
            display: block !important;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none !important;
        }
    }
</style>